import { useRef, useCallback } from 'react';
import { Box, Button, Stack, Text } from '@stitch-fix/mode-react';
import { SelfieUpload } from '../Selfie/SelfieUpload';
import PhotoTips from '../../PhotoTips';
import { SupportedBusinessLine } from '../../Onboarding';
interface OnboardingSelfieOnlyProps {
  selfieImageUrl?: string | null;
  businessLine?: SupportedBusinessLine;
  onSelfieChange?: () => void;
  hideInlineUploadActionsWhenEmpty?: boolean;
}
const OnboardingSelfieOnly = ({
  selfieImageUrl,
  businessLine,
  onSelfieChange,
  hideInlineUploadActionsWhenEmpty = false
}: OnboardingSelfieOnlyProps) => {
  const uploadTriggerRef = useRef<(() => void) | null>(null);
  const handleUploadReady = useCallback((trigger: () => void) => {
    uploadTriggerRef.current = trigger;
  }, []);
  return <Box maxWidth={48} mx="auto" display="flex" style={{
    flexDirection: 'column',
    flex: 1
  }}>
      <Text setting="title-large" color="blue-45" mb={0.5}>
        Let’s get styling
      </Text>
      <Text setting="body-small" mb={2}>
        Share a headshot to see yourself in fresh outfits every week.
      </Text>

      <Stack spacing={3}>
        <SelfieUpload existingImageUrl={selfieImageUrl} onChange={onSelfieChange} hideInlineUploadActionsWhenEmpty={hideInlineUploadActionsWhenEmpty} onUploadReady={handleUploadReady} />
        {businessLine && <Box maxWidth="500px" mx="auto">
            <PhotoTips businessLine={businessLine} mode="headshot" />
          </Box>}
      </Stack>

      {!selfieImageUrl && <Box py={3} mx="auto" width="100%" px={{
      sm: 1.5,
      md: 2
    }} maxWidth="400px" style={{
      display: 'flex',
      marginTop: 'auto'
    }}>
          <Button onClick={() => uploadTriggerRef.current?.()} width="fill" mb={3}>
            Add photo
          </Button>
        </Box>}
    </Box>;
};
export default OnboardingSelfieOnly;